import { motion } from "framer-motion";
import { FileDown } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import SectionHeading from "@/components/SectionHeading";
import { useLanguage } from "@/hooks/useLanguage";
import { CATALOGS } from "@/data/products";

export default function Catalogs() {
  const { t } = useLanguage();

  return (
    <>
      <PageHeader titleKey="catalogsTitle" subtitleKey="catalogsSubtitle" />

      <section className="bg-steel-light section-padding px-4 sm:px-6 lg:px-8">
        <div className="content-container">
          <SectionHeading overlineKey="downloads" titleKey="companyCatalogs" descriptionKey="catalogsDesc" align="center" />

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {CATALOGS.map((catalog, i) => {
              const isAvailable = false;
              return (
                <motion.div
                  key={catalog.title}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 0.5, delay: i * 0.1, ease: [0.25, 0.46, 0.45, 0.94] }}
                  className="bg-white rounded-lg p-7 border border-muted-border transition-all duration-300 hover:shadow-card-hover flex flex-col"
                >
                  <div className="w-12 h-12 rounded-full bg-primary-deep/10 flex items-center justify-center mb-5">
                    <FileDown className="w-5 h-5 text-primary-deep" />
                  </div>
                  <h3 className="font-display font-bold text-lg text-graphite mb-2">{catalog.title}</h3>
                  <p className="text-sm text-steel leading-relaxed mb-5 flex-1">{catalog.description}</p>
                  {isAvailable ? (
                    <a href={catalog.filePath} download className="btn-primary w-full text-center">
                      {t("downloadPDF")}
                    </a>
                  ) : (
                    <button disabled className="w-full py-3 rounded-md bg-steel-light text-steel font-body font-semibold text-sm cursor-not-allowed border border-muted-border">
                      {t("comingSoon")}
                    </button>
                  )}
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
